/* eslint-disable */
<template>
  <div>
    <AiDialog class="progress-dialog"
                width="60%"
                height="40%"
                :visible.sync="visible"
                @close="closedetailDialog">
        <div slot="header" class="progress-dialog__header">
        上传
        </div>

        <div class="create-sub-dialog__creatARcontent">
        <div class="upload-area">
            <AiVideoUpload
              :postType ="postType"
              :itemData = "itemData"
              :fileTypes ="fileFilter"
              @finishUpload="onFinishUpload" />
          </div>
        </div>
    </AiDialog>
  </div>
</template>
<script>
export default {
	name: 'upload',
	props: {
		itemData: { type: Object, default: null },
        itemNum:{type:Number,default:0},
        postType:{type:Number,default:0},
        visible: {
            type: Boolean,
            default: false
            }
	},
     data() {
        return {
          fileFilter:['JPGE','jpg','png','mp4','MP4','mov','*','MOV']

        }
    },
    mounted() {

    },
     methods: {

        closedetailDialog(){
            this.$emit('close');
            // this.visible = false;
        },
        onFinishUpload(url){
          this.$emit('finishUpload', url);
        }
     }
}
</script>

<style lang="scss" scoped>
.progress-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }


  &__content {
    display: block;
    padding: 20px 16px;
  }

  &__loadingdiv{
    padding: 20px;
  }
}

.upload-area{
    display: block;
    align-items: center;
    margin-top: 15%;
    margin-left: 25%;
    width: 50%;
}

</style>
